import { useTrans } from '../../../hooks'
import { MenuItemType } from '../../../utils/types'
import { Button, ButtonRounded, Modal } from '../../atoms'
import { Close, Logo } from '../../icons'
import styles from './CountryLightbox.module.sass'

interface Props {
  item: MenuItemType
  className?: string
  isOpen?: boolean
  setIsOpen?: (v: boolean) => void
  setCookies?: (v: string, k?: string) => void
}

const CountryLightbox = (props: Props) => {
  const {
    item = undefined,
    className = '',
    isOpen = false,
    setIsOpen = () => undefined,
    setCookies = () => undefined,
  } = props

  const t = useTrans()

  return item ? (
    <Modal
      id="modal-country"
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className={styles.modal}
    >
      <div className={styles.layout}>
        {/* <button className={styles.icon} onClick={() => setIsOpen(false)}>
          <Close />
          </button> */}
        <div className={styles.content}>
          <div className={styles.headerContent}>
            <div className={styles.logo}>
              <Logo />
            </div>

            <ButtonRounded
              className={styles.icon}
              onClick={() => {
                setIsOpen(false)
                setCookies('current')
              }}
              icon={<Close />}
              theme="neutral20"
              size="xs"
            />
          </div>
          <div className={styles.innerContent}>
            <h3 className={styles.title}>{item?.name}</h3>
            <div className={styles.buttonContainer}>
              <Button
                label={item?.alias}
                size="lg"
                variant="primary"
                href={item?.url || '/'}
                onClick={() => {
                  setIsOpen(false)
                  if (setCookies) setCookies('new', item?.key)
                }}
                className={styles.button}
              />
              <Button
                label={t('Rimani in Emilgroup Italia')}
                size="lg"
                variant="secondary"
                onClick={() => {
                  setIsOpen(false)
                  if (setCookies) setCookies('current')
                }}
                className={styles.button}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  ) : (
    <></>
  )
}

export default CountryLightbox
